/* ==========================================================================
   Custom product blocks JS
   - <message-card-field>  : free message card
   - <extra-special-addons>: "Make It Extra Special" add-on products
   - .m-product-collapsible: collapsible tab plus / minus icon state
   ========================================================================== */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function url(path) {
    return ROOT.replace(/\/$/, '') + path;
  }

  function postJSON(path, body) {
    return fetch(url(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json();
    });
  }

  function getCart() {
    return fetch(url('/cart.js'), { headers: { Accept: 'application/json' } }).then(function (res) {
      return res.json();
    });
  }

  /* Let the theme (cart drawer / cart count) know something changed. */
  function notifyCart(cart) {
    try {
      document.querySelectorAll('[data-cart-count], .m-cart-count, .cart-count-bubble span').forEach(function (el) {
        el.textContent = cart.item_count;
      });
    } catch (e) {}

    ['cart:refresh', 'cart:updated', 'cart:build', 'ajaxProduct:added'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart: cart } }));
    });

    if (window.MinimogEvents && typeof window.MinimogEvents.emit === 'function') {
      window.MinimogEvents.emit('CART_UPDATED', { cart: cart });
    }
    if (window.MinimogTheme && window.MinimogTheme.Cart && typeof window.MinimogTheme.Cart.getCart === 'function') {
      try { window.MinimogTheme.Cart.getCart(); } catch (e) {}
    }
  }

  /* ------------------------------------------------------------------------
     Free message card
     ------------------------------------------------------------------------ */
  if (!customElements.get('message-card-field')) {
    customElements.define(
      'message-card-field',
      class extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('[data-mc-input]');
          this.store = this.querySelector('[data-mc-value]');
          this.counter = this.querySelector('[data-mc-counter]');
          this.button = this.querySelector('[data-mc-button]');
          this.note = this.querySelector('[data-mc-note]');
          if (!this.input) return;

          this.max = parseInt(this.dataset.max || '100', 10);
          this.autoSync = this.dataset.autoSync !== 'false';
          this.buttonText = this.button ? this.button.textContent.trim() : '';
          this.addedText = this.dataset.addedText || 'Message added';

          this.updateCounter();
          this.input.addEventListener('input', this.onInput.bind(this));
          if (this.button) this.button.addEventListener('click', this.onSave.bind(this));
        }

        onInput() {
          if (this.input.value.length > this.max) {
            this.input.value = this.input.value.slice(0, this.max);
          }
          this.updateCounter();
          this.classList.remove('is-invalid');
          if (this.classList.contains('is-added')) {
            this.classList.remove('is-added');
            if (this.button) this.button.textContent = this.buttonText;
          }
          if (this.autoSync && this.store) this.store.value = this.input.value;
        }

        updateCounter() {
          if (this.counter) this.counter.textContent = this.input.value.length + '/' + this.max;
        }

        onSave() {
          var value = this.input.value.trim();
          if (!value) {
            this.classList.add('is-invalid');
            this.input.focus();
            return;
          }
          if (this.store) this.store.value = value;
          this.classList.remove('is-invalid');
          this.classList.add('is-added');
          if (this.button) this.button.textContent = this.addedText;
          if (this.note) this.note.hidden = false;
          this.dispatchEvent(new CustomEvent('message-card:saved', { bubbles: true, detail: { value: value } }));
        }
      }
    );
  }

  /* ------------------------------------------------------------------------
     Make It Extra Special
     ------------------------------------------------------------------------ */
  if (!customElements.get('extra-special-addons')) {
    customElements.define(
      'extra-special-addons',
      class extends HTMLElement {
        connectedCallback() {
          this.cards = Array.from(this.querySelectorAll('[data-es-card]'));
          this.groups = Array.from(this.querySelectorAll('[data-es-group]'));
          this.tabs = Array.from(this.querySelectorAll('[data-es-tab]'));
          this.scroller = this.querySelector('[data-es-scroller]');
          this.tabsTrack = this.querySelector('[data-es-tabs]');
          this.tabsWrap = this.querySelector('[data-es-tabs-wrap]');
          this.pinned = this.querySelector('[data-es-pinned]');
          this.body = this.querySelector('[data-es-body]');
          this.busy = false;
          this.pageMode = this.dataset.scrollMode === 'page';
          this.scrollOffset = parseInt(this.dataset.scrollOffset || '0', 10);
          this.stickyEnabled =
            this.pageMode && this.pinned && this.pinned.classList.contains('is-sticky');

          this.initCollapse();
          this.initCards();
          this.initSliders();
          this.initTabs();
          this.initStickyTabs();
          this.syncFromCart();

          this.boundSync = this.syncFromCart.bind(this);
          ['cart:refresh', 'cart:updated', 'cart:change'].forEach(
            function (name) {
              document.addEventListener(name, this.boundSync);
            }.bind(this)
          );
        }

        disconnectedCallback() {
          if (this.stickyActive) this.releaseSticky();
          if (this.boundMeasure) window.removeEventListener('resize', this.boundMeasure);
          if (this.boundSpy && this.spyTarget) this.spyTarget.removeEventListener('scroll', this.boundSpy);
          if (this.boundSticky) {
            window.removeEventListener('scroll', this.boundSticky);
            window.removeEventListener('resize', this.boundSticky);
          }
          ['cart:refresh', 'cart:updated', 'cart:change'].forEach(
            function (name) {
              document.removeEventListener(name, this.boundSync);
            }.bind(this)
          );
        }

        /* ---------------- collapse ---------------- */
        initCollapse() {
          var header = this.querySelector('[data-es-header]');
          var collapsible = this.dataset.collapsible === 'true' && header && this.body;
          var expanded = this.getAttribute('aria-expanded') === 'true';

          if (expanded) this.classList.add('is-open');

          if (!collapsible) {
            if (this.body) this.body.style.height = 'auto';
            return;
          }

          this.body.style.height = expanded ? 'auto' : '0px';

          header.addEventListener(
            'click',
            function () {
              var open = this.getAttribute('aria-expanded') === 'true';
              if (open) {
                this.classList.remove('is-open');
                if (this.releaseSticky && this.stickyActive) this.releaseSticky();
                this.body.style.height = this.body.scrollHeight + 'px';
                requestAnimationFrame(
                  function () {
                    this.body.style.height = '0px';
                    this.setAttribute('aria-expanded', 'false');
                  }.bind(this)
                );
              } else {
                this.setAttribute('aria-expanded', 'true');
                this.body.style.height = this.body.scrollHeight + 'px';
                setTimeout(
                  function () {
                    if (this.getAttribute('aria-expanded') === 'true') {
                      this.body.style.height = 'auto';
                      this.classList.add('is-open');
                      if (this.measureMedia) this.measureMedia();
                      if (this.updateSticky) this.updateSticky();
                    }
                  }.bind(this),
                  320
                );
              }
              header.setAttribute('aria-expanded', String(!open));
            }.bind(this)
          );
        }

        /* ---------------- cards ---------------- */
        initCards() {
          this.cards.forEach(
            function (card) {
              var add = card.querySelector('[data-es-add]');
              var plus = card.querySelector('[data-es-plus]');
              var minus = card.querySelector('[data-es-minus]');
              var id = parseInt(card.dataset.variantId, 10);

              if (add) add.addEventListener('click', this.addItem.bind(this, card, id));
              if (plus) plus.addEventListener('click', this.stepItem.bind(this, card, id, 1));
              if (minus) minus.addEventListener('click', this.stepItem.bind(this, card, id, -1));
            }.bind(this)
          );
        }

        setCardState(card, qty) {
          var label = card.querySelector('[data-es-qty]');
          if (qty > 0) {
            card.classList.add('is-added');
            if (label) label.textContent = qty;
          } else {
            card.classList.remove('is-added');
            if (label) label.textContent = '1';
          }
          card.dataset.qty = qty;
        }

        syncFromCart() {
          if (!this.cards.length) return Promise.resolve();
          return getCart()
            .then(
              function (cart) {
                this.cart = cart;
                var map = {};
                (cart.items || []).forEach(function (item) {
                  map[item.variant_id] = { qty: item.quantity, key: item.key };
                });
                this.cards.forEach(
                  function (card) {
                    var id = parseInt(card.dataset.variantId, 10);
                    var entry = map[id];
                    card.dataset.lineKey = entry ? entry.key : '';
                    this.setCardState(card, entry ? entry.qty : 0);
                  }.bind(this)
                );
              }.bind(this)
            )
            .catch(function () {});
        }

        addItem(card, id) {
          if (this.busy) return;
          this.busy = true;
          card.classList.add('is-loading');

          var properties = {};
          if (card.dataset.esProperty) properties[card.dataset.esProperty] = card.dataset.esPropertyValue || 'Yes';

          postJSON('/cart/add.js', {
            items: [{ id: id, quantity: 1, properties: properties }]
          })
            .then(
              function () {
                return this.afterChange(card);
              }.bind(this)
            )
            .catch(
              function () {
                this.busy = false;
                card.classList.remove('is-loading');
              }.bind(this)
            );
        }

        stepItem(card, id, delta) {
          if (this.busy) return;
          var current = parseInt(card.dataset.qty || '0', 10);
          var next = current + delta;
          if (next < 0) next = 0;

          this.busy = true;
          card.classList.add('is-loading');
          this.setCardState(card, next);

          var lineKey = card.dataset.lineKey;
          var payload = lineKey ? { id: lineKey, quantity: next } : { id: id, quantity: next };

          postJSON('/cart/change.js', payload)
            .then(
              function () {
                return this.afterChange(card);
              }.bind(this)
            )
            .catch(
              function () {
                this.busy = false;
                card.classList.remove('is-loading');
                this.syncFromCart();
              }.bind(this)
            );
        }

        afterChange(card) {
          return this.syncFromCart().then(
            function () {
              this.busy = false;
              card.classList.remove('is-loading');
              if (this.cart) notifyCart(this.cart);
            }.bind(this)
          );
        }

        /* ---------------- sliders ---------------- */
        initSliders() {
          this.measureMedia();
          this.boundMeasure = this.measureMedia.bind(this);
          window.addEventListener('resize', this.boundMeasure);

          Array.from(this.querySelectorAll('[data-es-slider]')).forEach(function (slider) {
            var track = slider.querySelector('[data-es-track]');
            var prev = slider.querySelector('[data-es-prev]');
            var next = slider.querySelector('[data-es-next]');
            if (!track) return;

            var step = function () {
              var card = track.querySelector('.m-es-card');
              var gap = parseFloat(getComputedStyle(track).columnGap || '14') || 14;
              return card ? card.offsetWidth + gap : track.clientWidth * 0.8;
            };

            var update = function () {
              var max = track.scrollWidth - track.clientWidth - 2;
              if (prev) prev.disabled = track.scrollLeft <= 2;
              if (next) next.disabled = track.scrollLeft >= max;
            };

            if (prev) prev.addEventListener('click', function () { track.scrollLeft -= step(); });
            if (next) next.addEventListener('click', function () { track.scrollLeft += step(); });
            track.addEventListener('scroll', update, { passive: true });
            window.addEventListener('resize', update);
            update();
          });
        }

        measureMedia() {
          var img = this.querySelector('.m-es-card__image');
          if (!img) return;
          var h = img.getBoundingClientRect().height;
          if (h) this.style.setProperty('--es-media-h', Math.round(h) + 'px');
        }

        /* ---------------- tabs ---------------- */
        initTabs() {
          if (!this.tabs.length) return;

          var self = this;
          this.tabs.forEach(function (tab) {
            tab.addEventListener('click', function () {
              var target = self.querySelector('#' + tab.dataset.esTab);
              if (!target) return;
              self.userScrolling = true;
              self.setActiveTab(tab);

              if (self.pageMode) {
                var top = target.getBoundingClientRect().top + window.pageYOffset - self.stickyOffset();
                window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
              } else if (self.scroller) {
                var delta = target.getBoundingClientRect().top - self.scroller.getBoundingClientRect().top;
                self.scroller.scrollTo({ top: self.scroller.scrollTop + delta, behavior: 'smooth' });
              }

              clearTimeout(self.scrollLock);
              self.scrollLock = setTimeout(function () { self.userScrolling = false; }, 700);
            });
          });

          /* scroll spy — on the window in page mode, on the inner scroller otherwise */
          this.spyTarget = this.pageMode ? window : this.scroller;
          if (this.spyTarget) {
            this.boundSpy = this.onSpyScroll.bind(this);
            this.spyTarget.addEventListener('scroll', this.boundSpy, { passive: true });
          }

          this.initTabsNav();
        }

        stickyOffset() {
          var extra = this.stickyEnabled && this.pinned ? this.pinned.offsetHeight : 0;
          return this.scrollOffset + extra;
        }

        /* JS-driven sticky header — portals title + tabs to <body> when stuck,
           so an ancestor transform / overflow (Minimog scroll-animations) cannot trap position:fixed. */
        initStickyTabs() {
          if (!this.stickyEnabled || !this.pinned || !this.pinned.parentNode) return;

          this.pinnedHome = this.pinned.parentNode;
          this.stickyPlaceholder = document.createElement('div');
          this.stickyPlaceholder.className = 'm-extra-special__pinned-placeholder';
          this.stickyPlaceholder.style.display = 'none';
          this.pinnedHome.insertBefore(this.stickyPlaceholder, this.pinned);

          this.stickyActive = false;
          this.boundSticky = this.updateSticky.bind(this);
          window.addEventListener('scroll', this.boundSticky, { passive: true });
          window.addEventListener('resize', this.boundSticky);
          this.updateSticky();
        }

        /* Copy the CSS custom properties the pinned header relies on, so it
           still themes correctly once it is moved out to <body>. */
        carryStyleVars() {
          var vars = [
            '--es-accent',
            '--es-title-size',
            '--es-tab-size',
            '--es-sticky-bg',
            '--es-radius'
          ];
          var cs = getComputedStyle(this);
          var self = this;
          vars.forEach(function (name) {
            var v = cs.getPropertyValue(name);
            if (v) self.pinned.style.setProperty(name, v.trim());
          });
          var font = cs.fontFamily;
          if (font) this.pinned.style.fontFamily = font;
          this.pinned.style.color = cs.color;
        }

        updateSticky() {
          if (!this.stickyEnabled || !this.pinned) return;
          if (this.getAttribute('aria-expanded') === 'false') {
            if (this.stickyActive) this.releaseSticky();
            return;
          }

          var top = this.scrollOffset;
          var pinnedH = this.pinned.offsetHeight;
          var ref = this.stickyActive ? this.stickyPlaceholder : this.pinned;
          var refTop = ref.getBoundingClientRect().top;

          var lastGroup = this.groups[this.groups.length - 1];
          var regionBottom = lastGroup
            ? lastGroup.getBoundingClientRect().bottom
            : this.body.getBoundingClientRect().bottom;

          var shouldStick = refTop <= top && regionBottom > top + pinnedH;
          var rect = this.getBoundingClientRect();

          if (shouldStick) {
            if (!this.stickyActive) {
              this.stickyPlaceholder.style.height = pinnedH + 'px';
              this.stickyPlaceholder.style.display = 'block';
              this.carryStyleVars();
              this.pinned.classList.add('is-stuck');
              this.pinned.style.position = 'fixed';
              this.pinned.style.top = top + 'px';
              this.pinned.style.zIndex = '999';
              document.body.appendChild(this.pinned);
              this.stickyActive = true;
            }
            this.pinned.style.left = rect.left + 'px';
            this.pinned.style.width = rect.width + 'px';
          } else if (this.stickyActive) {
            this.releaseSticky();
          }
        }

        releaseSticky() {
          if (this.pinnedHome && this.stickyPlaceholder) {
            this.pinnedHome.insertBefore(this.pinned, this.stickyPlaceholder);
          }
          this.pinned.classList.remove('is-stuck');
          this.pinned.style.position = '';
          this.pinned.style.top = '';
          this.pinned.style.left = '';
          this.pinned.style.width = '';
          this.pinned.style.zIndex = '';
          this.pinned.style.fontFamily = '';
          this.pinned.style.color = '';
          if (this.stickyPlaceholder) this.stickyPlaceholder.style.display = 'none';
          this.stickyActive = false;
        }

        onSpyScroll() {
          if (this.userScrolling || !this.groups.length) return;
          var active = this.groups[0];

          if (this.pageMode) {
            var line = this.stickyOffset() + 28;
            this.groups.forEach(function (group) {
              if (group.getBoundingClientRect().top <= line) active = group;
            });
          } else {
            var scrollerTop = this.scroller.getBoundingClientRect().top;
            this.groups.forEach(function (group) {
              if (group.getBoundingClientRect().top - scrollerTop <= 24) active = group;
            });
          }

          var tab = this.tabs.filter(function (t) { return t.dataset.esTab === active.id; })[0];
          if (tab && !tab.classList.contains('is-active')) this.setActiveTab(tab);
        }

        setActiveTab(tab) {
          this.tabs.forEach(function (t) { t.classList.remove('is-active'); });
          tab.classList.add('is-active');
          if (this.tabsTrack) {
            var left = tab.offsetLeft - this.tabsTrack.clientWidth / 2 + tab.offsetWidth / 2;
            this.tabsTrack.scrollTo({ left: left, behavior: 'smooth' });
          }
        }

        initTabsNav() {
          var prev = this.querySelector('[data-es-tabs-prev]');
          var next = this.querySelector('[data-es-tabs-next]');
          var track = this.tabsTrack;
          if (!track) return;

          var update = function () {
            var max = track.scrollWidth - track.clientWidth - 2;
            if (prev) prev.disabled = track.scrollLeft <= 2;
            if (next) next.disabled = track.scrollLeft >= max || max <= 0;
          };

          if (prev) prev.addEventListener('click', function () { track.scrollLeft -= 160; });
          if (next) next.addEventListener('click', function () { track.scrollLeft += 160; });
          track.addEventListener('scroll', update, { passive: true });
          window.addEventListener('resize', update);
          update();
        }
      }
    );
  }

  /* ------------------------------------------------------------------------
     Collapsible tab — plus / minus icon state
     Adds .is-ct-open to .m-product-collapsible while its tab is open,
     so the CSS can cross-fade the + into a −.
     ------------------------------------------------------------------------ */
  function ctIsOpen(tab) {
    if (tab.hasAttribute('open')) return true;
    if (tab.classList.contains('is-open') || tab.classList.contains('open')) return true;

    var btn = tab.querySelector('[data-trigger]');
    if (btn && btn.getAttribute('aria-expanded') === 'true') return true;

    var content = tab.querySelector('[data-content]');
    if (!content) return false;
    if (content.hasAttribute('hidden')) return false;
    if (content.style.display === 'none') return false;

    /* height-animated themes: 0px means closed */
    return content.getBoundingClientRect().height > 1;
  }

  function ctSync(wrapper) {
    var tab = wrapper.querySelector('collapsible-tab');
    if (!tab) return;
    wrapper.classList.toggle('is-ct-open', ctIsOpen(tab));
  }

  function ctInit(wrapper) {
    if (wrapper.dataset.ctIconInit === 'true') return;
    wrapper.dataset.ctIconInit = 'true';

    var tab = wrapper.querySelector('collapsible-tab');
    if (!tab) return;

    ctSync(wrapper);

    var btn = tab.querySelector('[data-trigger]');
    if (btn) {
      btn.addEventListener('click', function () {
        /* flip immediately for instant feedback */
        wrapper.classList.toggle('is-ct-open');
        /* then re-read the real state once the theme's animation settles */
        [60, 300, 600].forEach(function (t) {
          setTimeout(function () { ctSync(wrapper); }, t);
        });
      });
    }

    /* accordion behaviour: another tab opening may close this one */
    if (window.MutationObserver) {
      new MutationObserver(function () { ctSync(wrapper); }).observe(tab, {
        attributes: true,
        subtree: true,
        attributeFilter: ['open', 'class', 'hidden', 'aria-expanded', 'style']
      });
    }
  }

  function ctInitAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('.m-product-collapsible'), ctInit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { ctInitAll(); });
  } else {
    ctInitAll();
  }

  document.addEventListener('shopify:section:load', function (e) { ctInitAll(e.target); });
  document.addEventListener('shopify:block:select', function () { ctInitAll(); });
})();